import common from '@material-ui/core/colors/common';
import red from '@material-ui/core/colors/red';
const white = common.white;
const red500 = red['500'];
// import { cardTitle } from "../../../assets/jss/material-dashboard-pro-react.jsx";
import {cardTitle} from '../../../assets/jss/material-dashboard-pro-react.jsx'

const injectedCheckoutFormStyles = theme => ({
    formWrapper: {
        paddingBottom: '30px'
    },
    formLabel: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        margin: '23px 0',
        '& > div': {
            padding: '0'
        },
        '@media screen and (max-width: 600px)': {
            margin: '6px 0'
        }
    },
    formLabelCvv: {
        float: 'right',
        display: 'flex',
        flexDirection: 'column',
        marginTop: '30px',
        position: 'absolute',
        right: '10%',
        zIndex: '0',
        '& > div': {
            padding: '0'
        },
        '@media screen and (max-width: 600px)': {
            marginTop: '12px !important',
        },
        '@media screen and (max-width: 599px)': {
            right: '6%',
        },
    },
    formInput: {
        background: '#FFFFFF',
        border: '1px solid rgba(0, 0, 0, 0.13)',
        boxSizing: 'border-box',
        boxShadow: 'inset 4px 4px 4px rgba(0, 0, 0, 0.06)',
        borderRadius: '5px',
        padding: '18px !important',
        '& input': {
            padding: '0'
        }
    },
    formInputField: {
        background: '#FFFFFF',
        border: '1px solid rgba(0, 0, 0, 0.13)',
        boxSizing: 'border-box',
        boxShadow: 'inset 4px 4px 4px rgba(0, 0, 0, 0.06)',
        borderRadius: '5px',
        padding: '17.3px !important',
        outline: 'none'
    },
    frontCard: {
        background: '#FFFFFF',
        border: '1px solid rgba(0, 0, 0, 0.34)',
        boxSizing: 'border-box',
        borderRadius: '5px',
        maxWidth: '79.04%',
        position: 'relative',
        zIndex: '1'
    },
    backCard: {
        position: 'absolute',
        border: '1px solid rgba(0, 0, 0, 0.14)',
        top: '3%',
        right: '4.7%',
        maxWidth: '79.04%',
        background: '#F1F1F1',
        height: '34.445%',
        borderRadius: '5px',
        zIndex: '0',
        '@media screen and (max-width: 599px)': {
            height: '28.445%',
            right: '8.7%',
        },
    },
    backCardGridItem: {
        padding: '0 !important'
    },
    backCardStripe: {
        background: '#D6D6D6',
        height: '70px',
        marginTop: '14px'
    },
    modalActionsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        marginTop: '10px',
        '@media screen and (max-width: 611px)': {
            justifyContent: 'center'
        }
    },
    deleteBillingBtn: {
        padding: '9px 30px !important', 
        background: '#fff !important', 
        border: '3px solid !important', 
        color: '#B9002C !important',
        borderImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0.35) 0%, rgba(185, 0, 44, 0) 100%), linear-gradient(0deg, #B9002C, #B9002C) 1 strech !important'
    },
    cancelBtn: {
        background: '#000 !important', 
        boxShadow: '4px 4px 18px 1px rgba(27, 97, 237, 0.35) !important', 
        borderRadius: '3px !important', 
        width: '122px !important', 
        color: '#FFFFFF !important'
    },
    submitBtn: {
        background: '#1B23ED !important', 
        boxShadow: '4px 4px 18px 1px rgba(27, 97, 237, 0.35) !important', 
        borderRadius: '3px !important',  
        width: '122px !important',  
        color: '#FFFFFF !important'
    }
});

export default injectedCheckoutFormStyles;



// WEBPACK FOOTER //
// ./src/containers/billing/jss/InjectedCheckoutFormStyles.js